<template>
    <div class="referral-confirmation">
        <common-content-spacer :isCenter="true" height="large">
            <common-content-spacer :isCenter="true" height="small">
                <common-confirmation-icon :type="type"></common-confirmation-icon>

                <common-page-header
                    :heading="heading"
                    :isCenter="centerHeading"
                    class="referral-confirmation__heading"
                ></common-page-header>
            </common-content-spacer>

            <common-content-wrapper width="medium">
                <div class="referral-confirmation__body">
                    <slot name="content"></slot>
                </div>
            </common-content-wrapper>

            <slot name="footer"></slot>
        </common-content-spacer>
    </div>
</template>

<script>
    export default {
        props: {
            heading: { type: String, required: true },
            type: { type: String, required: true },
            isCenter: { type: Boolean, default: false },
            centerHeading: { type: Boolean, default: false },
        },
    }
</script>
